import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getSession } from "../actions/adminActions";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "../helpers/Modal";
import { useDispatch } from "react-redux";
var countDownTimer;
const withSessionTimeout = (Component) => {
  const NewComponent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [errorType, setErrorType] = useState("");
    const { pathname } = useLocation();

    const [session, setSession] = useState({
      time: 0,
      open: false,
    });
    useEffect(() => {
      (async function session() {
        const { session, requestError } = await getSession();

        if (requestError) {
          dispatch({ type: "LOGOUT" });
          if (
            requestError.param === "NoToken" &&
            pathname !== "/" &&
            pathname !== "/login" &&
            pathname !== `/product/${id}`
          ) {
            navigate("/login", {
              state: {
                message: "Unauthorized. Please login",
              },
            });
          } else if (
            requestError.param === "InvalidToken" &&
            pathname !== "/" &&
            pathname !== "/login" &&
            pathname !== `/product/${id}`
          ) {
            navigate("/login", {
              state: { message: "Session timeout. Please login again!" },
            });
          }
        } else {
          timer(session);
        }
      })();
      return () => setSession(null);
    }, []);

    function timer(timestamps) {
      //time converted
      const countDown = new Date(timestamps).getTime();

      countDownTimer = setInterval(() => {
        const now = new Date(
          new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })
        ).getTime();
        const distance = countDown - now;
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (minutes === 0 && seconds <= 0) {
          clearInterval(countDownTimer);

          dispatch({ type: "LOGOUT" });

          navigate("/login", {
            state: {
              prevState: pathname,
              message: "Session timeout! Please login again.",
            },
          });
          setSession({ time: false });
        } else if (
          minutes === 0 &&
          seconds <= 30 &&
          minutes === 0 &&
          seconds >= 0
        ) {
          setSession({ time: seconds });
        }
      }, 1000);
    }

    return (
      <>
        <Modal
          time={session?.time}
          setSession={setSession}
          timer={timer}
          countDownTimer={countDownTimer}
        ></Modal>
        <Component />
      </>
    );
  };
  return NewComponent;
};

export default withSessionTimeout;
